import React, { useMemo } from "react";
import CreatePlayerModal from "../../../../../../dsasComponents/feuillematch/CreatePlayerModal.js";
import { SelectPlayerOrdered } from "../../components/SelectPlayerOrdered.js";
import { Box } from "@mui/material";

const SelectPlayer = ({ keyValue, event, directEvent, onChange, custo, isFromOtherTeam }) => {

  const { holders, substitutes, others } = useMemo(() => {
    const teamLabel = directEvent.homeTeam._id === event.team ? isFromOtherTeam ? "away" : "home" : 
                      directEvent.awayTeam._id === event.team ? isFromOtherTeam ? "home" : "away" : null;

    if (!teamLabel) return { holders: [], substitutes: [], others: [] };

    const allPlayers = directEvent[`${teamLabel}Team`]?.players || [];
    const holders = directEvent[`${teamLabel}Holders`] || [];
    const substitutes = directEvent[`${teamLabel}Substitutes`] || [];

    // Les "autres" sont les joueurs qui sont dans players mais pas en titulaires/remplaçants
    const others = allPlayers.filter(
      (player) => !holders.some(h => h._id === player._id) && 
                  !substitutes.some(s => s._id === player._id)
    );

    const sortPlayers = (players) => players.sort((a, b) => {
      if (a.numero !== b.numero) return a.numero - b.numero;
      return a.lastname.localeCompare(b.lastname);
    });

    return {
      holders: sortPlayers(holders),
      substitutes: sortPlayers(substitutes),
      others: sortPlayers(others)
    };
  }, [directEvent, event.team]);

  return (
    <div className="select-player">

      <Box className="padding-wrapper display-grid">
        <SelectPlayerOrdered disabled={!event.team} match={directEvent} value={event[keyValue]} onChange={(value) => onChange(keyValue, value)} teamId={event.team} isFromOtherTeam={isFromOtherTeam} custo={custo}/>
      </Box>
      {event.team && <><Box className='centered-wrapper'>ou</Box>

      {/* Bouton pour ajouter un joueur */}
      <CreatePlayerModal 
        teamId={event.team} 
        discipline={directEvent.discipline} 
        provider={directEvent.provider} 
        match={directEvent}
      /></>}
    </div>
  );
};

export default SelectPlayer;
